// extracted by mini-css-extract-plugin
export default {"loader":"CardSpinner_loader__LWjK4","rotate":"CardSpinner_rotate__ixdGp","prixClipFix":"CardSpinner_prixClipFix__9toti"};